import { Injectable } from '@angular/core';
import { NotificationsType, NotificationType } from '@cargos/sprintpay-models';
import { StorageService } from '@cargos/sprintpay-services';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {
    private banners: BehaviorSubject<NotificationsType[]> = new BehaviorSubject<NotificationsType[]>([]);
    private popups: BehaviorSubject<NotificationsType[]> = new BehaviorSubject<NotificationsType[]>([]);

    constructor(private storageService: StorageService) {
        const currentBanners = this.storageService.getElement(NotificationType.BANNERS);
        const currentAlerts = this.storageService.getElement(NotificationType.ALERTS);
        if (currentBanners) {
            this.setBanners(currentBanners as NotificationsType[]);
        }
        if (currentAlerts) {
            this.setPopups(currentAlerts as NotificationsType[]);
        }
    }

    setBanners(notification: NotificationsType[]): void {
        this.banners.next(notification);
    }

    getBanners(): NotificationsType[] {
        return this.banners.value ? this.banners.value : this.storageService.getElement(NotificationType.BANNERS);
    }

    setPopups(notifications: NotificationsType[]): void {
        this.popups.next(notifications);
    }

    getPopups(): NotificationsType[] {
        return this.popups.value ? this.popups.value : this.storageService.getElement(NotificationType.ALERTS);
    }

    setNotifications(notification: NotificationsType[], type: NotificationType): void {
        this.storageService.saveElement(type, notification);
        if (type === NotificationType.BANNERS) {
            this.setBanners(notification);
            return;
        }
        this.setPopups(notification);
    }

    getPopupsUnread(): Observable<NotificationsType[]> {
        return this.popups.pipe(map((items) => items.filter((item) => item.display)));
    }

    getNotifications$(type: NotificationType): Observable<NotificationsType[]> {
        return type === NotificationType.BANNERS ? this.banners.asObservable() : this.getPopupsUnread();
    }

    saveNotifications(notifications: NotificationsType[], type: NotificationType): void {
        const notificationsBy = this.storageService.getElement(type);
        if (notificationsBy != undefined) {
            const currentNotifications: NotificationsType[] = JSON.parse(JSON.stringify(notificationsBy || ''));
            const newNotifications: NotificationsType[] = [];
            notifications.map((notification) => {
                const existNotification = !!currentNotifications.find(
                    (currentNotification) => currentNotification.name === notification.name
                );
                if (!existNotification) {
                    newNotifications.push(notification);
                }
            });
            currentNotifications.map((notification, index) => {
                const existNotification = !!notifications.find(
                    (newNotification) => newNotification.name === notification.name
                );
                if (!existNotification) {
                    currentNotifications.splice(index, 1);
                }
            });
            const updateNotifications = currentNotifications.concat(newNotifications);
            this.setNotifications(updateNotifications, type);
        } else {
            this.setNotifications(notifications, type);
        }
    }

    updateNotification(updateNotification: NotificationsType, type: NotificationType): void {
        const notifications = this.storageService.getElement(type);
        const currentNotifications: NotificationsType[] = JSON.parse(JSON.stringify(notifications || ''));
        const indexNotification = currentNotifications.findIndex(
            (notification) => notification.name === updateNotification.name
        );
        currentNotifications[indexNotification] = updateNotification;
        this.setNotifications(currentNotifications, type);
    }
}
